// スクリーニング(企業) 項目から探す 表示内容保存
export const RESULT_DATA_SET =
  "tools/screening/industry/result-data/RESULT_DATA_SET";
// スクリーニング(企業) 項目から探す 表示内容クリア
export const RESULT_DATA_CLEAR =
  "tools/screening/industry/result-data/RESULT_DATA_CLEAR";
